import { ReactComponent as User } from "../../assets/user.svg";
import { ReactComponent as Package } from "../../assets/package.svg";
import "./index.scss";
import classNames from "classnames";
import GlobalState, { changeMenuState } from "../../stores/GlobalState";
import { observer } from "mobx-react";
import { runInAction } from "mobx";
import Hearts from "../Hearts";
import ContentState from "../../stores/ContentState";
import { useLocation } from "react-router";
import { useEffect, useState } from "react";
import LangSelect from "../LangSelect";
const Navigation = observer(() => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      setVisible(true);
    }, 300);
  }, []);

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        const items = document.querySelectorAll(".navigation__item");

        items.forEach((i) => {
          const href = i.getAttribute("href")?.trim();
          if (href && window.location.href.includes(href)) {
            i.classList.add("active");
          }
        });
      }, 100);
    }
  }, [visible]);

  useEffect(() => {
    if (GlobalState.isMenuOpen) {
      document.querySelector(".hamburger")?.classList.add("active");
    } else document.querySelector(".hamburger")?.classList.remove("active");
  }, [GlobalState.isMenuOpen]);

  let lang = GlobalState.currentLocale.lang.includes("En")
    ? "/en"
    : GlobalState.currentLocale.lang.includes("ру")
    ? "/ru"
    : "";

  if (!ContentState.menu) return <></>;
  return (
    <>
      <nav className={classNames("navigation")}>
        <div className="navigation__list">
          {ContentState.menu.list?.map((l: any, id: number) => (
            <a
              href={l.link}
              className={classNames(
                "navigation__item",
                l.link.includes("track") && "track"
              )}
              target={l.link.includes("http") ? "__blank" : ""}
              key={id}
              onClick={() => {
                runInAction(() => {
                  GlobalState.isMenuOpen = false;
                  GlobalState.isLocaleOpen = false;
                });
              }}
            >
              <span> {l.title}</span>
              {l.link.includes("track") && <Hearts />}
            </a>
          ))}
        </div>
        <div className="navigation__func">
          <LangSelect />
          <div
            className={classNames(
              "navigation__func-item package",
              pathname.includes("/track") && "active"
            )}
            onClick={() => (window.location.href = ContentState.menu!.track)}
          >
            <Package />
          </div>
          <div
            className={classNames(
              "navigation__func-item user",
              (pathname.includes("/account") ||
                pathname.includes("/login") ||
                pathname.includes("/reg")) &&
                "active"
            )}
            onClick={() => window.open(ContentState.menu.account, "_blank")}
          >
            <User />
          </div>

          <div
            className={classNames("navigation__func-item hamburger")}
            onClick={changeMenuState}
          >
            <div className="hamburger__dash"></div>
            <div className="hamburger__dash"></div>
          </div>
        </div>
      </nav>
    </>
  );
});

export default Navigation;
